"use client"

import React, { useState } from "react"

interface RobotTabsProps {
  children: React.ReactNode & {
    props: {
      robot: string
    }
  }
  supportedRobots: string[]
}

export const RobotTabs: React.FC<RobotTabsProps> = ({
  children,
  supportedRobots,
}) => {
  const [selectedRobot, setSelectedRobot] = useState(supportedRobots[0])

  // Filter the content to display only for the selected robot
  const filteredChildren = React.Children.map(children, (child) => {
    if (React.isValidElement(child)) {
      if (child.props.robot === selectedRobot) {
        return child
      }
    }
    return null
  })

  return (
    <div>
      {/* Radio Buttons to select robot type */}
      <div
        style={{
          marginTop: "20px", // Add top margin to the radio button container
          marginBottom: "20px", // Add bottom margin to the radio button container
        }}
      >
        {supportedRobots.map((robot) => (
          <label
            key={robot}
            style={{
              display: "inline-block",
              marginRight: "20px", // Adds spacing between the radio buttons
            }}
          >
            <input
              type="radio"
              value={robot}
              checked={selectedRobot === robot}
              onChange={() => setSelectedRobot(robot)}
              style={{
                accentColor: "#831eff", // Changes the color of the radio button
                marginTop: "10px", // Adds top margin to individual radio buttons
              }}
            />
            <span style={{ marginLeft: "8px" }}>{robot}</span>{" "}
            {/* Adds space between radio button and label */}
          </label>
        ))}
      </div>

      {/* Display the content for the selected robot */}
      <div>{filteredChildren}</div>
    </div>
  )
}

interface RobotProps {
  robot: string
  children: React.ReactNode
}

export const UR: React.FC<RobotProps> = ({ children }) => <>{children}</>
export const FANUC: React.FC<RobotProps> = ({ children }) => <>{children}</>
export const Yaskawa: React.FC<RobotProps> = ({ children }) => <>{children}</>
export const ABB: React.FC<RobotProps> = ({ children }) => <>{children}</>
export const KUKA: React.FC<RobotProps> = ({ children }) => <>{children}</>
